'use client';

import { c as _c } from "react/compiler-runtime";
import type { OnrampClient } from '@morfi/onramp-sdk';
import { useVerifiedPhoneKyc } from '@morfi/onramp-sdk/react';
import type { MoonPayWebProvider } from '@morfi/onramp-sdk/web';
import { useTranslations } from 'next-intl';
import { type ReactNode, useEffect, useRef } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Skeleton } from '@/components/ui/app-skeleton';
import { TOAST_IDS } from '@/config/toast-ids';
import { showToast } from '@/lib/ui/toast';
import { VerificationForm } from './funding-verification';
export function FundingPhoneKyc(t0) {
  const $ = _c(9);
  const {
    client,
    provider,
    customerId,
    onComplete
  } = t0;
  const flow = useVerifiedPhoneKyc(client, provider, customerId, onComplete);
  const t = useTranslations("onramp");
  const transientError = flow.verification.step === "ready" && flow.error && !flow.busy;
  const announcedError = useRef(false);
  let t1;
  let t2;
  if ($[0] !== t || $[1] !== transientError) {
    t1 = () => {
      if (transientError && !announcedError.current) {
        showToast({
          id: TOAST_IDS.ONRAMP_VERIFICATION_ERROR,
          message: t("verification_failed"),
          variant: "error"
        });
      }
      announcedError.current = transientError;
    };
    t2 = [transientError, t];
    $[0] = t;
    $[1] = transientError;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (flow.verification.step !== "ready") {
    let t3;
    if ($[4] !== flow.verification) {
      t3 = <VerificationForm key={flow.verification.step} verification={flow.verification} requireConsent={false} />;
      $[4] = flow.verification;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t3;
  if ($[6] !== flow || $[7] !== t) {
    t3 = <div className="rr-block flex flex-col gap-3" data-private="true">{flow.error ? <AnimatedButton loading={flow.busy} disabled={flow.busy} onClick={() => {
        flow.submit();
      }}>{t("retry")}</AnimatedButton> : <Skeleton className="h-24 w-full rounded-control" />}</div>;
    $[6] = flow;
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}